// extracted by mini-css-extract-plugin
export default {"processingRetention":"TabProcessingRetention_processingRetention__7taB9"};